































import {Component, Vue} from "vue-property-decorator"
import NavBar from "@/components/NavBar.vue"
import SideBar from "@/components/SideBar.vue"
import {vxm} from "@/store"
import {FlushMessage} from "@/interface"

@Component({components: {NavBar, SideBar}})
export default class App extends Vue {

  private initialized: boolean = false

  async created() {
    await vxm.app.initialize()
    await vxm.ui.initialize()
    this.initialized = true
  }

  get isAuth() {
    return vxm.auth.isAuth
  }

  get flushMessages(): FlushMessage[] {
    return vxm.app.flush_messages
  }

  deleteMessage(id: string) {
    vxm.app.deleteMessage(id)
  }
}
